<template>
    <div class="activeInstructions">
        <div class="windowView" :class="isHorizontal ? 'horizontal' : 'vertical'">
            <h3 class="h3_c">{{ $pageLanguage.introTitle }}</h3>
            <div class="input_user">
                <div v-html="windowsContent"></div>
            </div>
            <div class="btn"><span class="grey"  @click="$router.go(-1)">{{ $pageLanguage.closeBtnText }}</span></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'activeInstructions',
    data () {
        return {
            isHorizontal: window.screen.width > window.screen.height
        }
    },
    methods: {
    },
    computed: {
        windowsContent () {
            return localStorage.windowsContent
        },
        $pageLanguage () {
            return this.$language.page.activeInstructions
        }
    }
}
</script>
<style lang="less" scoped>
    .activeInstructions{
        width: 100%;
        height: 100%;
        position: relative;
        .windowView{
            position: absolute;
            top:0;
            left: 0;
            bottom:0;
            right: 0;
            margin: auto;
            background-color: #fff;
            border-radius: 10px;
            box-sizing: border-box;
            text-align: center;
            padding-top: 8px;
            &.horizontal {
                width: 430px;
                height: 320px;
            }
            &.vertical {
                width: 300px;
                height: 380px;
            }
        }
        h3.h3_c{
            font-size: 28px;
            color: #333;
            line-height: 92px;
            margin: 0;
        }
        .input_user{
            min-height: 145px;
            overflow-y: auto;
            overflow-x: hidden;
            div{
                margin: 0;
                display: inline-block;
                width: 90%;
                text-align: left;
                font-size: 18px;
                color: #333;
                line-height: 28px;
            }
        }
        .btn{
            span{
                display: inline-block;
                height: 40px;
                width: 90%;
                color: #fff;
                font-size: 18px;
                text-align: center;
                border-radius: 45px;
                line-height: 40px;
            }
            span.grey{
                background: #636268;
                margin-top: 20px;
            }
        }
    }
</style>
